import { getEventSheetsFuse } from 'pages/ScheduleV6/utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectVisibleSheetsForDate } from 'store/schedule/scheduleSelectors';


export const useV6MobileEvents = () => {
  const allSheets = useSelector(selectVisibleSheetsForDate);
  const searchValue = useSelector((store) => store.schedule.searchValue);

  const visibleSheets = useMemo(() => {
    const fuse = getEventSheetsFuse(allSheets);

    if (searchValue) return fuse.search(searchValue);
    return allSheets;
  }, [allSheets, searchValue]);

  const events = visibleSheets.slice();

  return events;
};

export default useV6MobileEvents;

